import { css } from 'linaria';
export const printLayout = "pinp2nh";

require("../../../.linaria-cache/src/components/content-layout/print-layout.linaria.module.css");